<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Публикация страниц</p>
      <template v-if="isAccessAllowed">
        <div class="table-container mb-16 js-table-arrow" v-if="items && items.length > 0">
          <table class="stockTable">
            <thead>
              <tr>
                <th>Наименование</th>
                <th>Ссылка</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody v-for="item in items" :key="item.id">
              <tr>
                <td :class="item.parentId ? 'subitem' : ''">
                  <input
                    type="text"
                    class="border-bottom"
                    v-model="item.name"
                    maxlength="250"
                    placeholder="Введите название"
                    :disabled="!canEdit"
                  />
                </td>
                <td>{{ item.link }}</td>
                <td>
                  <CheckboxInput
                    v-model="item.isActive"
                    label="Отображать на сайте"
                    :id="'chActive' + item.id"
                    :disabled="!canEdit"
                    @update:modelValue="changeActive(item)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="tabs-inner_container card">
            <div class="main-info card-info">
              <p>Не найдено меню.</p>
            </div>
          </div>
        </div>

        <div class="card-row btns" v-if="canEdit && items && items.length > 0">
          <ButtonComponent mod="border" @click="cancel"> Отменить изменения </ButtonComponent>
          <ButtonComponent mod="gradient-bg" @click="save"> Сохранить изменения </ButtonComponent>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import API from '../api/openClientMenu';

  const PERMISSIONS = {
    view: Constants.Permissions.MenuView,
    edit: Constants.Permissions.MenuEdit,
  };

  export default {
    name: 'OpenClientMenu',
    components: {
      ButtonComponent,
      CheckboxInput,
    },
    mixins: [security],
    data() {
      return {
        items: [],
        canEdit: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.loadMenu();
    },
    methods: {
      changeActive(item) {
        if (!item.parentId && !item.isActive) {
          this.items.forEach((w) => {
            if (w.parentId == item.id) w.isActive = false;
          });
        }
      },
      loadMenu() {
        API.search().then((response) => {
          this.items = response.data;
        });
      },
      cancel() {
        this.loadMenu();
      },
      save() {
        var itemsToSave = [];
        this.items.forEach((w) => {
          itemsToSave.push({
            id: w.id,
            isActive: w.isActive,
            name: w.name,
          });
        });

        API.save(itemsToSave)
          .then((response) => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (response && response.data) {
              this.items = response.data;
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btns button {
    margin-right: 1rem;
  }
  .table-container table {
    min-width: auto;
    width: 100%;
  }
  .table-container table.stockTable .subitem {
    padding-left: 3rem;
  }
  input.border-bottom {
    border-width: 0 0 1px 0;
    width: 100%;
    min-width: 450px;
    font-size: 12px;
  }
</style>
